import React, { useContext, useState } from "react"; 
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Input from 'components/Input'

import {  
    CentredContent,
    LoginSpacer,
    FormSpacer,
    RegisterForgot,
    ForgotLink,
    RegisterCall
} from './styled' 

import ContainerUnauthenticated from "containers/Unauthenticated";
import Button from "components/Button";
import { CoreContext } from "context/CoreContext";
import { DoLogin, ReadMe } from "services/authentication";
import { ReadProfiles } from "services/profile";
import { exposeStrapiError } from "utils";
import { parseProfile } from "utils/parser";

export default function Login(){ 
    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const [ loading, setLoading ] = useState(false)
    const { setUser, setProfiles, setCurrentProfile, backgrounds } = useContext(CoreContext)
    
    const [ form, setForm ] = useState({})
    const formValue = ref => { return form?.[ref] ? form?.[ref] : '' ;}
    const changeForm = ( value, ref ) => { setForm({ ...form, [ref]: value }) ;} 

    const valid = (verbose = false) => {  

        if(!formValue('identifier') || !formValue('identifier').length){ 
            if(verbose){ toast.error('Preencha o campo: Email') ;}
            return false; 
        }  

        if(!formValue('password') || !formValue('password').length){ 
            if(verbose){ toast.error('Preencha o campo: Senha') ;}
            return false; 
        }  

        return true
    } 

    const login = async () => {
        if(!valid(true)){ return ;}
        setLoading(true)
        const result = await DoLogin({ ...form, identifier: form.identifier?.replace(/ /g,'') })  
        setLoading(false)
        if(result && !exposeStrapiError(result)){
            completeLogin(result)
        } 
    }  

    const completeLogin = async (result) => {
        if(result?.user){ setUser(result.user) }
        const profiles = await ReadProfiles()
        const me = await ReadMe() 

        if(me?.active_profile){
            setCurrentProfile(parseProfile(me?.active_profile))
        }else{
            setCurrentProfile(null)
        }

        console.log(me, profiles)

        if(profiles?.length){ 
            setProfiles(profiles.map(parseProfile))
            navigate('dashboard/select-profile')
        }else{ 
            setProfiles([])
            navigate('dashboard/create-profile')
        }
    }  

    const sign = () => { 
        navigate('register')
    }  
 
    return ( 
        <>  
            <ContainerUnauthenticated image={backgrounds?.find(fnd => fnd.locale === 'login')?.url}>  
                <CentredContent> 
                    <Input placeholder="E-mail" value={formValue('identifier')} onChange={e => changeForm(e.target.value, 'identifier')} /> 
                    <FormSpacer />
                    <Input placeholder="Senha" type="password" value={formValue('password')} onChange={e => changeForm(e.target.value, 'password')} />   
                    <RegisterForgot> 
                        <ForgotLink onClick={() => navigate('forgot')}>Recupere sua senha</ForgotLink>
                    </RegisterForgot> 
                    <FormSpacer /> 
                    <Button primary loading={loading} onClick={login}>Entrar</Button>
                    <Button green onClick={sign}>Assinar</Button>
                    <RegisterCall> &nbsp;</RegisterCall>
                    {/* <Button white outline onClick={() => navigate('dashboard')}>Conhecer a Joinkids</Button>  */}
                </CentredContent>
            </ContainerUnauthenticated> 
        </>
    );
}